import { IMRBaseComponent } from "../base"

import { IMRConfirmationPopupController } from "./confirmation-popup.controller"

//#region Asset Imports

import './confirmation-popup.scss'
import * as TEMPLATE from './confirmation-popup.tpl.html'

//#endregion

export const COMPONENT_NAME: string = 'imrConfirmationPopup'

export class IMRConfirmationPopupComponent extends IMRBaseComponent {

    constructor() {
        super({
            controller: IMRConfirmationPopupController,
            template: TEMPLATE
        })
    }
}